import * as Tool from '../tool'
import request from 'axios'
/**
 * 添加区域面积图，可叠加多层
 * @param {String} id 图层ID
 * @param {Object} config 配置项
 * @param {String} config.areaColor - red  底图填充的颜色
 * @param {String} config.lineColor - 'green|yellow' 线条的颜色，使用|分割，如'green|yellow'，将渲染2个线条
 * @param {String} delay 延时渲染时间
 */
export function addAreaShade(id, config, delay = 1000) {
  let mapbox = this.mapbox
  let zoom = mapbox.getZoom()
  let bearing = mapbox.getBearing() / 10
  let index = 0
  for (let file in config) {
    let animate = new Tool.Animate(mapbox, {
      frame: 10,
      delay: index * 1000 + delay
    })
    index++
    const cfg = config[file]
    // 读取配置
    const url = '.public/map/json/area/' + file + '.json' // 地址
    request.get(url).then(res => {
      const lineColor = cfg.lineColor || 'green|yellow'
      const lines = lineColor.split('|') // 线条颜色
      const layerId = id + file
      const opacity = cfg.opacity
      res.data.features.forEach(item => {
        item.properties.color = cfg.areaColor
      })
      mapbox.addSource(file, {
        type: 'geojson',
        data: res.data
      })
      let ly = {
        id: layerId,
        type: 'fill',
        source: file,
        layout: {},
        paint: {
          'fill-color': ['get', 'color'],
          'fill-opacity': 0 //蒙层透明度
        }
      }
      // 需区分瓦片和矢量
      if (mapbox.getLayer('building')) {
        mapbox.addLayer(ly, 'building')
      } else {
        mapbox.addLayer(ly)
      }
      animate.putPaint(layerId, 'fill-opacity', 0, opacity)
      animate.putTranslate(layerId, 'fill-translate', 20)

      let lineOpacity = 1 / lines.length

      for (let i = 0; i < lines.length; i++) {
        let layerId2 = layerId + i
        mapbox.addLayer({
          id: layerId2,
          type: 'line',
          source: file,
          minzoom: 12,
          paint: {
            'line-color': ['get', 'color'],
            'line-translate-anchor': 'map',
            'line-translate': getOffset(i),
            'line-opacity': 0,
            'line-width': 2 - i / 2
          }
        })
        if (i === 0) {
          animate.putPaint(layerId2, 'line-opacity', 0, lineOpacity * i)
        } else {
          animate.putPaint(layerId2, 'line-opacity', 0, 1)
        }
        animate.putTranslate(layerId2, 'line-translate', 20)
      }
      animate.start()
    })
  }
  function getOffset(i = 0) {
    let zoom = mapbox.getZoom()
    zoom = zoom < 14 ? 0 : zoom - 14
    let bearing = mapbox.getBearing()
    let pitch = mapbox.getPitch()
    if (bearing < 0) {
      bearing = -bearing
    }
    let x = i * (pitch / 50 + 2)
    let y = i * (zoom * 8 * (pitch / 20) - (bearing / 2) * (zoom / 2) + 0.5)
    return [x, -y]
  }
  function autoOffset() {
    let pitch = mapbox.getPitch()
    if (zoom > 11) {
      for (let key in config) {
        const cfg = config[key]
        const lineColor = cfg.lineColor || 'green|yellow'
        const lines = lineColor.split('|') // 线条颜色
        const layerId = id + key
        for (let i = 0; i < lines.length; i++) {
          mapbox.setPaintProperty(layerId + i, 'line-translate', getOffset(i))
          mapbox.setPaintProperty(
            layerId + i,
            'line-width',
            (2 - i / 2) * (1 + pitch / 60)
          )
        }
      }
    }
  }
  // 根据地图的zoom调整line的偏移
  mapbox.on('zoom', autoOffset)
  mapbox.on('rotate', autoOffset)
}

export function updateAreaShadeColor(id, fn) {
  let source = this.mapbox.getSource(id)
  source._data.features.forEach(item => {
    let color = fn(item.properties)
    item.properties.color = color
  })
  source.setData(source._data)
}



// WEBPACK FOOTER //
// ./src/framework/map/layer/AreaShade.js